<div class="page-layout p-24 blank marketplace-tour-operators" style="padding-bottom: 80px !important;">
  @if (loading) {
    <mat-progress-bar class='mt-24 mb-24' style='min-width:300px' mode="indeterminate"></mat-progress-bar>
  }
  @if (!domainHasBokunAccount && !loading) {
    <div class="message-settings-api">
      <h2>Credenziali Bokun</h2>
      <p>Per rivendere i tour presenti su Bokun è necessario un account vendor con accesso al marketplace.</p>
      <!-- redirect alla pagina dettaglio dominio da dove configura le chiavi API -->
      <p>Configura le tue credenziali <a [routerLink]='["/dataset/detail/domains/" + this.domainFilterService.filterDomainId.value]' [queryParams]='{step: 4}'>qui</a>.</p>
    </div>
  }
  @if (domainHasBokunAccount && !loading) {
    <div>
      <dataset-list
        datasetCode='bokun_tours'
        tableStyle='style-1 selectable btn-outlined'
      ></dataset-list>
    </div>
  }
</div>